const M = "/media/menu/";

export const BRAND = {
  name: "Blue Tequila",
  sub: "Mexican Restaurant · Grill & Cantina",
  est: "EST. 2016",
  city: "North Port · Florida",
  tagline: ["Big flavor.", "Bold tradition."],
  phone: "941-888-5332",
  phoneHref: "tel:+19418885332",
  address: "14525 Tamiami Trail, North Port, FL 34287",
  mapsHref: "https://maps.google.com/?q=14525+Tamiami+Trail+North+Port+FL+34287",
  orderUrl: "https://order.toasttab.com/online/blue-tequila/",
  facebook: "https://www.facebook.com/Bluetequilafl/",
};

export const HOURS = [
  { day: "Sunday", time: "12:00 PM — 8:00 PM" },
  { day: "Mon — Thu", time: "11:00 AM — 9:00 PM" },
  { day: "Fri — Sat", time: "11:00 AM — 10:00 PM" },
];

export const IMAGES = {
  hero: "/media/stock/b385d02ba778e366.jpg",
  heroFood: "/media/stock/5b7715d92e61b9c4.jpg",
  margaritas: "/media/stock/bcea1627e7680ba3.jpg",
  margaritaBlue: "/media/stock/1bde599012143d8f.jpg",
  tacosTeal: "/media/stock/ccb46a5bb66c1aa8.jpg",
  tacosPlate: "/media/stock/368433b470ab75c7.jpg",
  tiles: "/media/stock/d4c1a84076509138.jpg",
};

// Real restaurant photography (bundled static assets — ship with the build)
export const REAL_PHOTOS = {
  entrance: "/media/photos/photo_1.jpg",
  family: "/media/photos/photo_2.jpg",
  diningBar: "/media/photos/photo_3.jpg",
  bar: "/media/photos/photo_4.jpg",
  fiesta: "/media/photos/photo_5.jpg",
  mainDining: "/media/photos/photo_6.jpg",
  chandelier: "/media/photos/photo_7.jpg",
  interior: "/media/photos/photo_8.jpg",
};

export const HERO_MEDIA = {
  video: "/media/hero.mp4",
  poster: "/media/hero-poster.jpg",
};

export const CHAPTERS = [
  { no: "01", label: "The Family", title: "Family owned, endlessly poured.", body: "Blue Tequila was built on a love for bringing people together over great food, awesome drinks, and unforgettable moments. As a family owned and operated restaurant, we pour our passion into every detail — from the flavors in our kitchen to the warmth of our service." },
  { no: "02", label: "The Craft", title: "Fresh ingredients, bold taste.", body: "Traditional recipes and handcrafted drinks served in a warm, vibrant atmosphere. Everything is smashed, squeezed, and grilled to order — the way authentic Mexican cooking was always meant to be." },
  { no: "03", label: "The Fiesta", title: "Where friends become family.", body: "What started as a dream has grown into a place where celebrations come to life and every visit feels like coming home. Come hungry, leave happy — that's the Blue Tequila way." },
];

export const SIGNATURES = [
  { kicker: "Freshly Made", name: "Homemade Guacamole", desc: "Smashed fresh with lime, cilantro, onion and tomato. Served with warm tortilla chips.", img: IMAGES.heroFood, color: "#5B8A5B" },
  { kicker: "Street Style", name: "Mexican Street Tacos", desc: "Soft corn tortillas, your choice of meat, cilantro and onion, lime and homemade hot sauce.", img: IMAGES.tacosTeal, color: "#00B4D8" },
  { kicker: "Crafted Daily", name: "Passionate Sunset", desc: "Tequila, passionfruit, fresh squeezed orange juice and a raspberry liqueur floater.", img: IMAGES.margaritas, color: "#E76F51" },
];

export const MENU = {
  eats: [
    { name: "Mariam's Burrito", price: "$22.99", desc: "Flour tortilla stuffed with grilled chicken, rice and beans, topped with chorizo, pineapple, ham, onions and cilantro, smothered in cheese sauce.", img: M + "menu-image-4.80d947779972a89f765c.png" },
    { name: "Adelitas Quesabirrias", price: "$18.99", desc: "Corn tortillas dipped in birria broth with beef birria and melted cheese, grilled. Rice, grilled onions, jalapeño, cilantro and lime.", img: M + "menu-image-16.fb5fffa3234c774fe54e.png" },
    { name: "Fajita Chimichangas", price: "$25.99", desc: "Deep-fried tortillas stuffed with grilled steak, chicken or mixed, topped with cheese sauce. Rice and beans.", img: M + "menu-image-1.5b9d5d40c6cc804dd42d.png" },
    { name: "Blue Tequila Fajitas", price: "$26.99", desc: "Beef ribs, chorizo, chicken, steak and shrimp with grilled onions, bell peppers and tomatoes.", img: M + "menu-image-1.40141613475203a168c1.png" },
    { name: "Street Mexican Tacos", price: "$18.99", desc: "Three soft corn tortillas, choice of meat, cilantro and onions, rice, beans, lime and homemade hot sauce.", img: M + "menu-image-13.9281fdd3c37a5e8134c5.png" },
    { name: "Homemade Guacamole", price: "$11.99", desc: "Freshly smashed avocado with lime, cilantro, onion, tomato and sea salt. Warm tortilla chips.", img: M + "menu-image-8.e3844db728cf57fde40d.png" },
  ],
  drinks: [
    { name: "Passionate Sunset", price: "$12.00", desc: "Tequila, passionfruit, fresh squeezed orange juice and a raspberry liqueur floater.", img: "/media/stock/904048a96d61ca6e.jpg" },
    { name: "Skinny Margarita", price: "$12.99", desc: "Low calorie and fresh — tequila with fresh squeezed juices.", img: "/media/stock/12bff78438c00955.jpg" },
    { name: "Strawberry Mojito", price: "$10.00", desc: "Classic strawberry mojito with fresh fruit and mint.", img: "/media/stock/3a6199c8def0f73e.jpg" },
    { name: "Michelada", price: "$12.00", desc: "A Mexican Bloody-Mary with your choice of bottled beer.", img: "/media/stock/20f0e60e62e74718.jpg" },
    { name: "La Catrina", price: "$12.00", desc: "Rum, coconut and pineapple tropical drink with toasted coconut.", img: "/media/stock/ffc194c697922be5.jpg" },
    { name: "N/A Flamingo", price: "$5.99", desc: "Pineapple, coconut and watermelon Redbull with muddled mint and orange.", img: "/media/stock/d4603056a7439100.jpg" },
  ],
};

export const TESTIMONIALS = [
  { quote: "Love the atmosphere. Love the people. The food is amazing. Family oriented and a great date night place — a must for fantastic authentic Mexican food!", by: "Google Review", color: "#0047AB" },
  { quote: "We are never disappointed when we eat here. The staff is always accommodating and friendly. Authentic Mexican and the portions are enormous. Gracias.", by: "Google Review", color: "#E76F51" },
  { quote: "Comfortable, friendly staff and atmosphere. The margarita was the best we have had in Florida. Food was great — we will go back for sure.", by: "Google Review", color: "#00B4D8" },
];

export const RIBBON = ["Tacos", "Margaritas", "Fajitas", "Birria", "Guacamole", "Quesabirrias", "Micheladas", "Fiesta"];

export const GALLERY = [
  { img: REAL_PHOTOS.chandelier, name: "Grand Chandelier" },
  { img: REAL_PHOTOS.diningBar, name: "Dining Room & Bar" },
  { img: M + "menu-image-1.40141613475203a168c1.png", name: "Blue Tequila Fajitas" },
  { img: REAL_PHOTOS.fiesta, name: "Fiesta Dining Room" },
  { img: REAL_PHOTOS.family, name: "Our Family" },
  { img: M + "menu-image-16.fb5fffa3234c774fe54e.png", name: "Adelitas Quesabirrias" },
  { img: REAL_PHOTOS.bar, name: "The Bar" },
  { img: M + "menu-image-8.e3844db728cf57fde40d.png", name: "Homemade Guacamole" },
  { img: REAL_PHOTOS.mainDining, name: "Main Dining Room" },
  { img: REAL_PHOTOS.entrance, name: "Entrance & Art" },
  { img: IMAGES.margaritas, name: "House Margaritas" },
  { img: REAL_PHOTOS.interior, name: "Colorful Interior" },
];

export const CELEBRATE = [
  { title: "Happy Hour", tag: "Mon – Fri · 3–6 PM", desc: "Half-price house margaritas, tequila and appetizers at the bar — the perfect way to start the fiesta.", img: IMAGES.margaritas, color: "#E76F51", cta: { label: "See the drinks", href: "/menu" } },
  { title: "Catering", tag: "Any occasion", desc: "Sizzling fajitas, tacos and fresh margaritas brought straight to your event, made to order.", img: M + "menu-image-1.91edb30cecdcc57b401e.png", color: "#0047AB", cta: { label: "Call to plan", href: "tel:+19418885332" } },
  { title: "Private Parties", tag: "Celebrate with us", desc: "Birthdays, anniversaries and family gatherings — big flavors, lively vibes and lasting memories.", img: IMAGES.tacosTeal, color: "#6B3FA0", cta: { label: "Book a table", href: "tel:+19418885332" } },
];
